import React, { Fragment, useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import LoaderComponent from "../../CommonUtils/LoaderComponent/LoaderComponent";

export default function MessageA62(props) {
    const { item, tag } = props;
    const timer = JSON.parse(item.data);

    const [applied, setApplied] = useState(true);
    const [timerInstance, setTimerInstance] = useState(0);
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        if (item?.uiCommand === "A62") {
            setApplied(true);
            setShowLoader(false); // Hide loader initially
            setTimerInstance(prev => prev + 1); // Force re-render

            // 🔹 Add delay before showing the loader (smooth transition)
            setTimeout(() => setShowLoader(true), 300); // Adjust delay as needed
        }
    }, [item]);

    return (
        <Fragment>
            <AnimatePresence mode="wait">

                {applied && showLoader && (
                        <LoaderComponent
                            key={timerInstance}
                            time={timer.waitSecs}
                            onClickSubmit={(code, data, tag) => {
                                props?.addMessages(null, props?.item?.code, props?.item?.text, "loader", null);
                            }}
                            tag={tag}
                            code={item.code}
                            filterToggle={(data) => setApplied(data)}
                            showMaximumChat={props?.showMaximumChat}
                        />

                )}
            </AnimatePresence>
        </Fragment>
    );
}